// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';

export const filterReportsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const filterReportsQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Start date for the report period (ISO 8601 format: YYYY-MM-DD)")),
  until: z.optional(z.string().date().describe("End date for the report period (ISO 8601 format: YYYY-MM-DD)")),
  user_ids: z.optional(z.coerce.string().describe("Comma-separated list of user IDs to filter by")),
  project_ids: z.optional(z.coerce.string().describe("Comma-separated list of project IDs to filter by")),
  client_ids: z.optional(z.coerce.string().describe("Comma-separated list of client IDs to filter by")),
  label_ids: z.optional(z.coerce.string().describe("Comma-separated list of label IDs to filter by")),
  team_ids: z.optional(z.coerce.string().describe("Comma-separated list of team IDs to filter by (requires teams feature)")),
  state_ids: z.optional(z.coerce.string().describe("Comma-separated list of state IDs to filter by")),
  group_by: z.optional(z.coerce.string().describe("Comma-separated list of grouping keys: clients, users, labels, days, teams. Default: all groups")),
  scope: z.optional(z.enum(["totals", "events"]).describe("Result scope: totals (aggregated data) or events (individual entries). Default: totals")),
  billed: z.optional(z.enum(["true", "false"]).describe("Filter by billed status")),
}).optional();

export const filterReportsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Report events retrieved successfully
 */
export const filterReports200Schema = z.array(z.unknown());

/**
 * @description Forbidden - teams feature required
 */
export const filterReports403Schema = z.lazy(() => v1ForbiddenErrorSchema);

export const filterReportsQueryResponseSchema = z.lazy(() => filterReports200Schema);
